/** Single JSON-LD script node for structured data. */
const JsonLd = ({ data }) => {
    if (!data) {
        return null;
    }
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
};

export default JsonLd;
